/** @typedef {Object} RowExpanderStrategy
 * @property {function(JQuery): *} getRowKey
 * @property {function(*): string} getDetailRowId
 * @property {string} gridSelector
 * @property {string} rowSelector
 * @property {string} [expandedContainerSelector='.data-grid-item']
 */

/** @param {RowExpanderStrategy} strategy */
function createRowExpander(strategy) {
    const containerSel = strategy.expandedContainerSelector || '.data-grid-item';

    function getKey($row) {
        return strategy.getRowKey($row);
    }

    function getContainer($row) {
        return $row.closest(containerSel);
    }

    function getDetailRow(key) {
        const id = strategy.getDetailRowId(key);
        if (!id) {
            return $();
        }
        const el = document.getElementById(id);
        return el ? $(el) : $();
    }

    function getRowFromContainer($container) {
        if ($container.is(strategy.rowSelector)) {
            return $container;
        }
        return $container.find(strategy.rowSelector).first();
    }

    return {
        /** @param {JQuery} $row @returns {boolean} */
        isExpanded($row) {
            const key = getKey($row);
            if (key == null) return false;
            const $detail = getDetailRow(key);
            return $detail.length > 0 && $detail.is(':visible');
        },

        /** @param {JQuery} $row @param {*} key @returns {void} */
        collapse($row, key) {
            getContainer($row).removeClass('expanded');
            $row.removeClass('expanded');
            getDetailRow(key).hide();
        },

        /** @param {JQuery} $row @param {JQuery} $detailRow @returns {void} */
        expand($row, $detailRow) {
            getContainer($row).addClass('expanded');
            $row.addClass('expanded');
            $detailRow.css('display', 'block').show();
        },

        /** @param {JQuery} $row @returns {void} */
        collapseAllExcept($row) {
            const self = this;
            $(strategy.gridSelector + ' ' + containerSel + '.expanded').each(function () {
                const $item = $(this);
                if ($row.closest(containerSel).is($item)) return;
                const $r = getRowFromContainer($item);
                const key = getKey($r);
                if (key != null) self.collapse($r, key);
            });
        },

        /** @param {JQuery} $row @returns {void} */
        toggle($row) {
            const key = getKey($row);
            if (key == null) return;

            const $detail = getDetailRow(key);
            if (this.isExpanded($row)) {
                this.collapse($row, key);
                return;
            }

            this.collapseAllExcept($row);
            if ($detail.length) this.expand($row, $detail);
        }
    };
}

export default createRowExpander;
